/* ═══ FAQ ACCORDION ═══ */
document.querySelectorAll('.faq-q').forEach(q => {
  q.addEventListener('click', () => {
    const item = q.parentElement;
    const wasOpen = item.classList.contains('open');
    // close all in same section
    item.closest('.faq-list').querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    // toggle clicked
    if (!wasOpen) item.classList.add('open');
  });
});

/* ═══ FAQ SEARCH ═══ */
function filterFAQ(query) {
  const q = query.toLowerCase().trim();
  document.querySelectorAll('.faq-item').forEach(item => {
    const text = (item.getAttribute('data-q') || '') + ' ' + item.textContent.toLowerCase();
    item.style.display = (!q || text.includes(q)) ? '' : 'none';
  });
  // show/hide section headers based on visible items
  document.querySelectorAll('.faq-list').forEach(list => {
    const visible = list.querySelectorAll('.faq-item[style=""], .faq-item:not([style])').length;
    const section = list.closest('.faq-section');
    if (section) {
      const header = section.querySelector('.faq-section-header');
      if (header) header.style.display = visible > 0 ? '' : 'none';
    }
  });
}

/* ═══ CATEGORY NAV ═══ */
function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) {
    const offset = 120;
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  document.querySelectorAll('.cat-pill').forEach(p => p.classList.remove('active'));
  const pill = document.querySelector('.cat-pill[data-sec="' + id + '"]');
  if (pill) pill.classList.add('active');
}

/* ═══ STICKY BAR (rAF-throttled) ═══ */
const faqStickyBar = document.getElementById('stickyBar');
const faqSections = ['programs', 'bodytype', 'results', 'nutrition', 'app', 'pricing'];
const faqPills = document.querySelectorAll('.cat-pill');
let faqTicking = false;
window.addEventListener('scroll', () => {
  if (faqTicking) return;
  faqTicking = true;
  requestAnimationFrame(() => {
    if (faqStickyBar) {
      faqStickyBar.classList.toggle('visible', window.scrollY > 600);
    }
    faqSections.forEach((id, i) => {
      const el = document.getElementById(id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 200 && rect.bottom > 200) {
          faqPills.forEach(p => p.classList.remove('active'));
          if (faqPills[i]) faqPills[i].classList.add('active');
        }
      }
    });
    faqTicking = false;
  });
});